<template>
  <v-container class="pt-10 pb-5">
    <h1 class="text-h4">{{ studyList.name }}</h1>
    <p class="mt-4">
      {{ termLanguage }} → {{ meaningLanguage }} •
      {{ studyList.item_count }} words
    </p>

    <p v-if="studyList.description" style="max-width: 50rem;">
      {{ studyList.description }}
    </p>

    <div v-if="loggedIn">
      <v-btn
        elevation="0"
        color="primary"
        :to="{ name: 'AudioStudy', params: { id: studyList.id.toString() } }"
      >
        <v-icon>mdi-play</v-icon> Audio Study
      </v-btn>

      <v-btn
        class="ml-4"
        :to="{ name: 'StudyListEdit', params: { id: studyList.id } }"
        icon
      >
        <v-icon color="grey lighten-1">mdi-pencil</v-icon>
      </v-btn>

      <v-btn
        class="ml-4"
        :to="{ name: 'StudyListImportTerms', params: { id: studyList.id } }"
        icon
      >
        <v-icon color="grey lighten-1">mdi-import</v-icon>
      </v-btn>

      <v-btn
        icon
        class="ml-4"
        @click="deleteStudyListConfirmation(studyList.id)"
      >
        <v-icon color="grey lighten-1">mdi-delete</v-icon>
      </v-btn>
    </div>

    <v-card v-else class="mt-8 pa-md-3 gradient" dark>
      <v-card-title class="text-h5" style="word-break: normal;"
        >Study vocabulary audio-first and hands-free</v-card-title
      >
      <v-card-text>
        <ul class="text-subtitle-1 white--text" style="line-height: 1.7">
          <li>Liteword is an audio player for word lists</li>
          <li>Each word is repeated at timed intervals</li>
          <li>Remember words efficiently and with correct pronunciation</li>
        </ul>

        <v-btn
          x-large
          color="white"
          class="mt-5 black--text"
          :to="{ name: 'AudioStudy', params: { id: studyList.id.toString() } }"
        >
          <v-icon>mdi-play</v-icon> Audio Study
        </v-btn>

        <div class="mt-6">
          <a
            class="white--text text-decoration-none font-weight-medium"
            href="/account/signup"
            >Sign up for free</a
          >
          to create your own word lists like this.
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<style scoped>
.gradient {
  background-image: linear-gradient(145deg, #4101f5, #ea1e32);
  background-repeat: no-repeat;
}
</style>

<script>
import { mapGetters, mapActions } from "vuex";

import { LANGUAGE_MAP } from "@/common/constants";

import PlayerService from "@/common/player.service";

export default {
  methods: {
    ...mapActions(["play", "updatePlayingInfo", "deleteStudyList"]),
    onStudyClick(item) {
      PlayerService.setCurrentStudyList(item.id);
      this.updatePlayingInfo({ subtitle: item.name });
      this.play();
    },
    deleteStudyListConfirmation(id) {
      if (confirm("Delete this list?")) {
        this.$store.dispatch("deleteStudyList", id).then(() => {
          this.$router.push("/");
        });
      }
    },
  },
  computed: {
    ...mapGetters(["studyList", "loggedIn"]),

    termLanguage() {
      return LANGUAGE_MAP[this.studyList.term_language];
    },
    meaningLanguage() {
      return LANGUAGE_MAP[this.studyList.meaning_language];
    },
  },
};
</script>
